export default {fields:{archiveRecord:{fields:{purpose:{}},typenameResolver:'ArchiveRecordTypenameResolver'}}}